<template>
    <div class="row">
        <div class="col-12">
            <div class="apex-chart-container">
                <apexchart type="bar" height="350" :options="chartOptions" :series="series"></apexchart>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import {Money} from './../../../services/Money.js';
export default {
    name: "BarBasic",
    data: function() {
        return {
            money:new Money(),
            colors:['#008000', '#FF0000', '#0000FF', '#FFFF00', '#800000', '#FF8C00', '#800080', '#FF00FF', '#808080', '#00FFFF', '#00FF00', '#FF1493', '#DEB887', '#FFD700', '#FFC0CB', '#90EE90', '#BC8F8F', '#00BFFF', '#7B68EE', '#4682B4', '#ADFF2F', '#808000', '#008080', '#DCDCDC', '#8B4513', '#2F4F4F', '#B8860B', '#EEE8AA', '#DC143C', '#FA8072'],

        }
    },
    components: {
        apexchart: VueApexCharts,
    },
    props:{
        chartData:{
            type:Object
        } ,
        documents:{
            type:Array
        },
        analyzeType:{
            type:String,
        },
        analyzeLevel: {
            type: Object
        },
        currency:{
            type:String
        },
    },
    computed: {
        series() {
            return [{
                name: this.__('net_base_currency_value').replace("base_currency", this.currency),
                data: this.sumObjectsByKey(this.documents, this.chartData.crit_1).map((item) => item.data),
            }];
        },

        chartOptions() {
            let objectSum = this.sumObjectsByKey(this.documents, this.chartData.crit_1)
            const self = this;
            return {
                chart: {
                    type: 'bar',
                    height: 350,
                    defaultLocale: 'pl',
                    locales: [{
                        name: 'pl',
                        options: {
                            toolbar: {
                                exportToSVG:$.i18n._('chart_export_SVG'),
                                exportToPNG:$.i18n._('chart_export_PNG') ,
                                exportToCSV:$.i18n._('chart_export_CSV'),
                                zoomIn:$.i18n._('chart_zoom_in'),
                                zoomOut:$.i18n._('chart_zoom_out'),
                                pan:$.i18n._('chart_pan'),
                                reset:$.i18n._('chart_reset'),
                            }
                        }
                    }],
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none' // Wyłącza przezroczystość na hover
                        }
                    }
                },
                colors:this.colors,
                plotOptions: {
                    bar: {
                        borderRadius: 4,
                        horizontal: true,
                    }
                },
                dataLabels: {
                    enabled: false
                },
                xaxis: {
                    categories: objectSum.map((item) => item.name),
                    labels: {
                        formatter: function (val) {
                            return self.money.localizeWithInt(val);
                        },
                    },
                },
                yaxis: {
                    title: {
                        text: this.__("net_value_in_base_currency"),
                        style: {
                            fontSize: '9px',
                        }
                    },
                    min: 0, // Minimalna wartość na osi Y
                    max: this.getMax(), // Maksymalna wartość na osi Y,
                    forceNiceScale:true,
                },
                tooltip: {
                    y: {
                        formatter: function (value, series) {
                            return self.money.localize(value);
                        }
                    }
                },
                title: {
                    text: this.getTitle(),
                    align: 'left'
                },
            }
        }


    },
    methods:{
        roundToNextTen(value) {
            // Zaokrąglanie w górę do najbliższej potęgi 10
            return Math.ceil(value / 10) * 10;
        },

        formatWithZeros(value) {
            // Formatowanie wartości z zerami
            return value.toFixed(0);
        },

        getMax() {
            let max = Number.NEGATIVE_INFINITY;

            for (const obj of this.series) {
                const maxValueInSeries = Math.max(...obj.data);

                // Zaokrąglenie wartości do najbliżej większej potęgi 10
                const roundedValue = this.roundToNextTen(maxValueInSeries);

                // Formatowanie wartości z zerami
                const formattedValue = parseFloat(this.formatWithZeros(roundedValue));
                if (formattedValue > max) {
                    max = formattedValue;
                }
            }
            return parseFloat(max);
        },
        getTitle() {
            let transPart = this.chartData.crit_1;
            if(transPart == 'date_item_name' && this.analyzeLevel.date_segregation == 'year'){
                transPart = 'years';
            }
            if (this.analyzeType == 'sell') {
                return this.__("analyze_sell_part") + ' ' + this.__(transPart)
            } else {
                return this.__("analyze_buy_part") + ' ' + this.__(transPart)

            }
        },
        sumObjectsByKey(arr, key) {
            const result = [];

            if (key === 'date_item_name' && this.analyzeLevel.date_segregation == 'month') {
                // Jeśli klucz to 'date_item_name', znajdź minimalną i maksymalną datę
                const dateValues = arr.map(obj => new Date(obj['date_chart']));
                const minDate = new Date(Math.min(...dateValues));
                const maxDate = new Date(Math.max(...dateValues));
                minDate.setDate(1);
                minDate.setHours(0, 0, 0, 0);
                maxDate.setHours(0, 0, 0, 0);
                // Utwórz listę miesięcy między minimalną a maksymalną datą
                const monthsBetween = [];
                let currentDate = minDate;
                while (currentDate <= maxDate) {
                    monthsBetween.push(currentDate.toLocaleString(navigator.language, {
                        year: 'numeric',
                        month: 'long'
                    }));
                    currentDate.setMonth(currentDate.getMonth() + 1);
                    currentDate.setHours(0, 0, 0, 0);
                }

                // Przetwarzaj każdy miesiąc, obliczając sumę dla każdego
                for (const month of monthsBetween) {
                    const sum = arr
                        .filter(obj => obj[key] === month)
                        .reduce((total, obj) => total + obj.net_in_base_currency, 0);

                    result.push({'name': month, data: sum});
                }
            } else {
                // Standardowe przetwarzanie dla innych kluczy
                const uniqueValues = [...new Set(arr.map(obj => obj[key]))];
                uniqueValues.sort((a, b) => {
                    const aOrder = arr.find(obj => obj[key] === a)[key.replace('_name', '_order')];
                    const bOrder = arr.find(obj => obj[key] === b)[key.replace('_name', '_order')];
                    return aOrder - bOrder;
                });
                for (const value of uniqueValues) {
                    const sum = arr
                        .filter(obj => obj[key] === value)
                        .reduce((total, obj) => total + obj.net_in_base_currency, 0);
                    let categoryName = value;
                    if(categoryName == 'UNALLOCATED'){
                        if(key == 'order_item_name'){
                            categoryName = this.__("rest_items")
                        }
                        else if(key == 'contractor_item_name'){
                            categoryName = this.__("rest_contractors")
                        }
                    }
                    result.push({'name': categoryName, data: sum.toFixed(2)});
                }
            }
            return result.filter(obj => obj.name !== 'REST');
        },
    }

}
</script>

<style scoped>

</style>
